import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';
import mergers from 'seamless-immutable-mergers';

export const { Types, Creators } = createActions({
  getRecommendationsRequest: ['page', 'qtyProducts'],
  getRecommendationsSuccess: ['data'],
  getRecommendationsError: ['error'],

  getPaginate: ['data'],

  getProductsPaginatedRequest: ['recommendationData'],
  getProductsPaginatedSuccess: ['data'],
  getProductsPaginatedError: ['error'],
});

const INITIAL_STATE = Immutable({
  error: {},
});

const getRecommendationsSuccess = (state = INITIAL_STATE, { data: { placements } }) => state.merge(placements);

const getRecommendationsError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const getPaginate = (state = INITIAL_STATE, { data: { recommendation, pagination } }) =>
  state.setIn([recommendation, 'pagination'], pagination);

const getProductsPaginatedSuccess = (state = INITIAL_STATE, { data: { recommendation, products, pagination } }) => {
  const mergeRecommendation = Immutable.merge(
    state.getIn([recommendation], {}),
    { products, pagination },
    {
      merger: mergers.updatingByIdArrayMerger,
      mergerObjectIdentifier: 'id',
    }
  );

  return state.merge({ [recommendation]: mergeRecommendation });
};

const getProductsPaginatedError = (state = INITIAL_STATE, { error }) => state.set('error', { ...error });

export default createReducer(INITIAL_STATE, {
  [Types.GET_RECOMMENDATIONS_SUCCESS]: getRecommendationsSuccess,
  [Types.GET_RECOMMENDATIONS_ERROR]: getRecommendationsError,
  [Types.GET_PAGINATE]: getPaginate,

  [Types.GET_PRODUCTS_PAGINATED_SUCCESS]: getProductsPaginatedSuccess,
  [Types.GET_PRODUCTS_PAGINATED_ERROR]: getProductsPaginatedError,
});
